import { useAppSelector } from "./storeHook";
import { userTeams } from "../store/reducers/mainReducer";

export default function useUserTeamsHook() {
  const teams = useAppSelector(userTeams);

  if (teams && teams.length > 0) {
    return teams;
  } else {
    // Retrieve data from localStorage if userProfile is not populated
    const talenvoUserTeams = localStorage.getItem("userTeams");
    if (talenvoUserTeams) {
      return JSON.parse(talenvoUserTeams);
    } else {
      return [];
    }
  }
}